var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAeroplane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 68,
    viewBox: "0 0 51 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.875 56.2703C31.875 60.2316 28.9863 67.1234 25.5 67.1234C21.9141 67.1234 19.125 60.2316 19.125 56.2703V42.7647L1.60371 31.1239C0.607613 30.4637 -3.8147e-06 29.2359 -3.8147e-06 27.9039V21.3943C-3.8147e-06 20.1666 1.01601 19.2747 2.03203 19.6106L19.125 25.2862V13.379L13.3875 8.37524C12.9891 8.02776 12.75 7.47178 12.75 6.89264V2.02785C12.75 1.12439 13.3775 0.40625 14.1445 0.40625C14.274 0.40625 14.4035 0.429416 14.533 0.464164L25.5 4.11276L36.467 0.464164C36.5965 0.417833 36.726 0.40625 36.8555 0.40625C37.6324 0.40625 38.25 1.13597 38.25 2.02785V6.89264C38.25 7.47178 38.0109 8.02776 37.6125 8.37524L31.875 13.379V25.2978L48.968 19.6222C49.984 19.2747 51 20.1666 51 21.3943V27.9039C51 29.2359 50.3824 30.4637 49.3963 31.1239L31.875 42.7647V56.2703Z",
    fill: "url(#paint0_linear_3194_309)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3194_309",
    x1: 28.1607,
    y1: 58.1538,
    x2: 31.5194,
    y2: 9.31544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D63715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA7D06"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAeroplane);
export default __webpack_public_path__ + "static/media/aeroplane.69fee9b30645d84a6f177163432a1c30.svg";
export { ForwardRef as ReactComponent };